import React, { useState, useEffect } from 'react';

const Posters = ({}) => {

  // const [data, setData] = useState(null);

  useEffect(() => {
  }, [])

  return (
    <div className="admin-channel-design">
      holds posters
    </div>
  )
}

export default Posters;